import { StyledBlogEditorRow, TitleTextarea, RemoveButton, Title } from '../BlogEditor.style';
import { FormDataType } from '../interfaces/index';
import React from 'react';
import { FiMinus } from 'react-icons/fi';
import { FormFieldProps } from '../interfaces/index';
export const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  value,
  onChange,
  type = 'text',
  hasRemoveButton = false,
}: {
  label: string;
  name: keyof FormDataType;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  type?: string;
  hasRemoveButton?: boolean;
}) => (
  <StyledBlogEditorRow>
    <Title htmlFor={name}>{label}</Title>
    <TitleTextarea id={name} name={name} value={value} hasValue={value.length > 0} onChange={onChange} rows={1} />
    {hasRemoveButton && <RemoveButton aria-label={`Remove ${label}`}>{FiMinus({ size: 28, color: '#000000' })}</RemoveButton>}
  </StyledBlogEditorRow>
);
